export default __webpack_public_path__ + "static/media/blue-bell.d23e2886.svg";